import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleAccordionCollapse} from "@/helpers/bootstrap-accordion-helper";
import {initPopper} from "@/modules/popper";

const template = document.createElement('template');

export class LayerMenuOverviewCollapseComponent extends HTMLElement{
    constructor(){
        super();

        const collapse = this.getAttribute('data-collapse')
        const accordionClass = this.getAttribute('data-accordion-class')

        if(collapse === "true") {
            template.innerHTML =  `
          <button class="btn waves-effect icon-btn popper-header" type="button">
             <span class="fa fa-compress-alt rotate-135"></span>
             <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Catalogus inklappen
                <div class="arrow" data-popper-arrow=""></div>
              </div>
          </button>`
        } else {
            template.innerHTML =  `
          <button class="btn waves-effect icon-btn popper-header" type="button">
               <span class="fa fa-expand-alt rotate-135"></span>
               <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Catalogus uitklappen
                <div class="arrow" data-popper-arrow=""></div>
              </div>
          </button>`
        }

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            toggleAccordionCollapse(accordionClass, collapse)
        })

        initPopper()
    }
}
